module.exports = __webpack_public_path__ + "img/f1.cc992887.jpg";